import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "ChevronDown",
  [
    [
      "path",
      {
        d: "M14.56 10.95c0.59 0.59 0.59 1.53 0 2.12l-9 9c-0.59 0.59-1.53 0.59-2.12 0s-0.59-1.53 0-2.12L11.36 12 3.45 4.09c-0.59-0.59-0.59-1.53 0-2.12s1.53-0.59 2.12 0l9 9z",
      },
    ],
  ],
  "currentColor"
);
